"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterStaffForAccess = filterStaffForAccess;
exports.loadCaregiverPanel = loadCaregiverPanel;
exports.useSchedulingAccess = useSchedulingAccess;
var vue_1 = require("vue");
var vuex_1 = require("vuex");
var axios_1 = require("axios");
var apis_1 = require("@/constants/apis");
var privileges_1 = require("@/stores/privileges");
var session_1 = require("@/stores/session");
var privileges_2 = require("@/constants/privileges");
var patients_1 = require("@/api2/patients");
// Mirrors WelcomeQuickNav.vue's isHealthcareProHomeGrid account-type list.
var HEALTHCARE_PRO_TYPES = {
    'provider': 'provider',
    'nurse': 'nurse',
    'registered nurse': 'nurse',
    'licensed practical nurse': 'nurse',
    'home health aid': 'hha',
    'home health aids': 'hha',
    'home health aide': 'hha',
    'home health aides': 'hha',
    'allied professional': 'allied',
    'allied professionals': 'allied',
};
// The API returns `account_type` as a snake_case slug (`registered_nurse`),
// while these maps are keyed on the spaced English labels the legacy backend
// emitted. Fold underscores to spaces so both spellings resolve to one key —
// without this every non-administrator staff type falls through to the
// patient branch and gets the patient-only screen.
function normalize(value) {
    return String(value || '').trim().toLowerCase().replace(/_/g, ' ');
}
/**
 * Restricts a staff/provider/nurse list to just the caller, for a locked
 * caregiver session -- a no-op for admin/patient access.
 *
 * WHY THIS EXISTS
 * Before this helper, ManageScheduling.vue and MasterCalendar.vue each
 * independently filtered their own staff lists by category only, never by
 * `access.kind` -- so a restricted caregiver's dropdown correctly *defaulted*
 * to their own name (selectedStaffId was already pinned to access.staffId)
 * but still *listed* every other nurse/HHA/provider in their category, and
 * nothing stopped manually picking someone else. Centralizing the fix here,
 * rather than patching each component's own computed list independently,
 * is deliberate -- that's exactly the kind of duplicated-and-partially-fixed
 * bug that caused the original gap. Every staff/provider/caregiver picker
 * across Scheduling should call this instead of filtering `store.providers`/
 * `store.nurses` itself.
 *
 * WHAT THIS IS NOT RESPONSIBLE FOR
 * - Patients: the patient list is already staff-scoped server-side via
 *   store.loadPatientsFromStaffPatientsGroup() (SqlClass::
 *   GetPatientsFromStaffPatientsGroup on the backend) -- there is no
 *   equivalent client-side leak to filter for patients, so this helper only
 *   ever narrows STAFF lists.
 * - Enforcement: this is a UX-correctness fix, not a security boundary --
 *   the actual authorization now happens server-side (SessionActor +
 *   AuthorizeSchedulingProviderActor/AuthorizeSchedulingAppointmentActor in
 *   keyon/). A bug here means a confusing dropdown, not a bypass; the
 *   backend gate is what actually prevents a restricted caregiver from
 *   acting on someone else's calendar even if this filter were removed.
 *
 * @param list   Any staff/provider/nurse array whose items carry an `id`
 *               matching SchedulingAccess['staffId'] (the signed-in user's id).
 * @param access The current SchedulingAccess, or null/undefined while it's
 *               still resolving -- treated the same as a non-caregiver
 *               access kind (no filtering) so callers don't need a separate
 *               loading check before calling this.
 * @return The unfiltered list for 'admin'/'patient' access (or while access
 *         is still resolving); for 'caregiver' access, the list narrowed to
 *         the single entry whose `id` matches `access.staffId` (or empty if
 *         the caller isn't in the list at all, or has no id yet).
 *
 * Ids are compared as text. `staffId` is `String(useSessionStore().userId)`,
 * while the rows come from the bridge as the API sent them: a nurse's id is a
 * string, a provider's (`Provider.GetAllAccountProviders`, `subaccountnumber =
 * user.id`) a number. Strict equality across the two left a locked provider
 * with an empty provider picker (review of 8614ccd6).
 */
function filterStaffForAccess(list, access) {
    // A clinician in a chart is the 'patient' kind (main's chart context) but
    // still acts only as themselves: the API books, moves and cancels a
    // non-administrator's own visits only (SchedulingAuthority, main #323), so
    // listing colleagues would offer choices the server refuses.
    var lockedTo = (access === null || access === void 0 ? void 0 : access.kind) === 'caregiver'
        ? access.staffId
        : (access === null || access === void 0 ? void 0 : access.kind) === 'patient' && access.viewerStaffId !== undefined
            ? access.viewerStaffId
            : null;
    if (lockedTo === null)
        return list;
    var staffId = String(lockedTo !== null && lockedTo !== void 0 ? lockedTo : '').trim();
    if (!staffId)
        return [];
    return list.filter(function (s) { var _a; return String((_a = s.id) !== null && _a !== void 0 ? _a : '').trim() === staffId; });
}
/** 100 is the API's page cap (ResourceQuery); 50 pages is a stop, not a size anyone has. */
var PANEL_PAGE_SIZE = 100;
var PANEL_MAX_PAGES = 50;
/**
 * The charts a caregiver may book on — main's
 * GetPatientsFromStaffPatientsGroup for a non-admin caregiver, which is the
 * calendar's patient picker (SchedulingCalendar). Every page of
 * `filter[assigned_user_id]`: one page of 100 quietly dropped the rest of a
 * larger panel from the picker.
 *
 * Only the charts the caregiver's own assignment lets them write to
 * (`filter[assignment_access]=write`): the server refuses a booking on any
 * other chart (SchedulingAuthority: a write assignment), so a chart they hold
 * read-only is left off the list instead of offered and then refused. This
 * list is display; the server is still the gate.
 *
 * Read by id: the panel is a set, and a unique key is the one order that two
 * pages cannot disagree on (last names tie, and a patient on a page boundary
 * would be read twice or not at all).
 *
 * @return the patient ids, as text
 */
function loadCaregiverPanel(staffId_1) {
    return __awaiter(this, arguments, Promise, function (staffId, list) {
        var ids, page, result, _i, _a, item, last;
        var _b;
        if (list === void 0) { list = patients_1.listPatients; }
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    ids = new Set();
                    page = 1;
                    _c.label = 1;
                case 1:
                    if (!(page <= PANEL_MAX_PAGES)) return [3 /*break*/, 4];
                    return [4 /*yield*/, list({
                            'filter[assigned_user_id]': staffId,
                            'filter[assignment_access]': 'write',
                            per_page: PANEL_PAGE_SIZE,
                            page: page,
                            sort: 'id'
                        })];
                case 2:
                    result = _c.sent();
                    for (_i = 0, _a = result.items || []; _i < _a.length; _i++) {
                        item = _a[_i];
                        ids.add(String(item.id));
                    }
                    last = Number((_b = result.meta) === null || _b === void 0 ? void 0 : _b.last_page) || 1;
                    if (page >= last)
                        return [3 /*break*/, 4];
                    _c.label = 3;
                case 3:
                    page += 1;
                    return [3 /*break*/, 1];
                case 4: return [2 /*return*/, ids];
            }
        });
    });
}
// Same webhook call as WelcomeQuickNav.vue's loadWelcomeGridMeta.
function fetchAccountType(accountnumber, subaccountnumber) {
    return __awaiter(this, void 0, Promise, function () {
        var res, e_1;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, axios_1.default.post("".concat(apis_1.CURR_API, "/tswebhook.php"), {
                            Account: { API_Meth: 'GetAccountType', accountnumber: accountnumber, subaccountnumber: subaccountnumber }
                        }, { headers: { 'Content-Type': 'application/json;' } })];
                case 1:
                    res = _c.sent();
                    return [2 /*return*/, ((_b = (_a = res.data) === null || _a === void 0 ? void 0 : _a.providerAssignment) === null || _b === void 0 ? void 0 : _b.accounttype) || ''];
                case 2:
                    e_1 = _c.sent();
                    console.error('useSchedulingAccess: GetAccountType failed', e_1);
                    return [2 /*return*/, ''];
                case 3: return [2 /*return*/];
            }
        });
    });
}
/**
 * The acting staff member's own id: the token's subject, from the session
 * (`GET /me`, decision D4), which the callers' `ensureLoaded` has waited for.
 * Only that. `allData.patient` is the open chart, so a fallback to its id made
 * a caregiver whose session had not loaded into the patient they were viewing.
 * With no id the caregiver is locked to nobody (filterStaffForAccess answers an
 * empty list) rather than to a guess.
 */
function sessionStaffId() {
    var userId = (0, session_1.useSessionStore)().userId;
    return userId === null || userId === undefined ? '' : String(userId);
}
/** The chart on screen, as the legacy `allData.patient` blob names it. */
function chartInView(data) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    var patientId = String((_d = (_b = (_a = data.patient) === null || _a === void 0 ? void 0 : _a.mid) !== null && _b !== void 0 ? _b : (_c = data.patient) === null || _c === void 0 ? void 0 : _c.externId) !== null && _d !== void 0 ? _d : '');
    var firstName = ((_e = data.patient) === null || _e === void 0 ? void 0 : _e.first_name) || ((_f = data.patient) === null || _f === void 0 ? void 0 : _f.firstName) || '';
    var lastName = ((_g = data.patient) === null || _g === void 0 ? void 0 : _g.lastname) || ((_h = data.patient) === null || _h === void 0 ? void 0 : _h.lastName) || '';
    return { patientId: patientId, patientName: "".concat(firstName, " ").concat(lastName).trim() };
}
/**
 * Resolves how the current session should see the Scheduling module:
 * - admin: unrestricted (existing behavior).
 * - caregiver: a non-admin provider/nurse/hha/allied pro on their own dashboard.
 * - patient: a self-service patient login, or anyone — a member of staff or a
 *   contact — currently viewing a patient chart. `allData.patient` is the
 *   chart in view and `allData.viewingPatientChart` says it is not the
 *   signed-in person's own; the viewer's own permissions decide `canAdd` and
 *   `fullAccess`.
 */
function useSchedulingAccess() {
    var vuex = (0, vuex_1.useStore)();
    var privStore = (0, privileges_1.usePrivilegesStore)();
    var allData = (0, vue_1.computed)(function () { return (vuex && vuex.getters ? vuex.getters['login/getAllData'] : {}); });
    var access = (0, vue_1.ref)(null);
    var loading = (0, vue_1.ref)(true);
    /**
     * Resolve, but never leave the page spinning.
     *
     * `resolve` is driven by a `watch(..., {immediate: true})`, so anything it
     * throws escapes as an unhandled rejection and `loading` stays true forever —
     * the caller renders a spinner and no error. A single try/finally here is the
     * difference between a visible failure and a page that never loads.
     */
    function resolve() {
        return __awaiter(this, void 0, void 0, function () {
            var e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        return [4 /*yield*/, resolveAccess()];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        e_2 = _a.sent();
                        console.error('useSchedulingAccess: could not resolve access', e_2);
                        access.value = null;
                        return [3 /*break*/, 4];
                    case 3:
                        loading.value = false;
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    function resolveAccess() {
        return __awaiter(this, void 0, void 0, function () {
            var data, accountnumber, accounttype, normalized, category, fullAccess_1, canAdd_1, _a, patientId, patientName, canAdd, fullAccess;
            var _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        loading.value = true;
                        data = allData.value || {};
                        accountnumber = (_b = data.patient) === null || _b === void 0 ? void 0 : _b.externId2;
                        if (!accountnumber) {
                            access.value = null;
                            loading.value = false;
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, fetchAccountType(accountnumber, (_c = data.patient) === null || _c === void 0 ? void 0 : _c.externId)];
                    case 1:
                        accounttype = _d.sent();
                        normalized = normalize(accounttype);
                        category = HEALTHCARE_PRO_TYPES[normalized];
                        if (!(data.viewingPatientChart && (normalized === 'administrator' || category))) return [3 /*break*/, 3];
                        return [4 /*yield*/, privStore.ensureLoaded()];
                    case 2:
                        _d.sent();
                        fullAccess_1 = privStore.effectiveGranted(privileges_2.PRIVILEGES.SCHEDULE_ADMINISTER);
                        canAdd_1 = fullAccess_1 || privStore.effectiveGranted(privileges_2.PRIVILEGES.PATIENT_SCHEDULING_ADD);
                        access.value = __assign(__assign(__assign({ kind: 'patient' }, chartInView(data)), { canAdd: canAdd_1, fullAccess: fullAccess_1 }), (fullAccess_1 ? {} : { viewerStaffId: sessionStaffId() }));
                        loading.value = false;
                        return [2 /*return*/];
                    case 3:
                        if (normalized === 'administrator') {
                            access.value = { kind: 'admin' };
                            loading.value = false;
                            return [2 /*return*/];
                        }
                        if (!category) return [3 /*break*/, 5];
                        return [4 /*yield*/, privStore.ensureLoaded()
                            // A provider/nurse/HHA/allied pro granted this privilege gets
                            // admin-equivalent scheduling access (every calendar, schedule for
                            // anyone) without being made a full org Administrator.
                        ];
                    case 4:
                        _d.sent();
                        // A provider/nurse/HHA/allied pro granted this privilege gets
                        // admin-equivalent scheduling access (every calendar, schedule for
                        // anyone) without being made a full org Administrator.
                        if (privStore.effectiveGranted(privileges_2.PRIVILEGES.SCHEDULE_ADMINISTER)) {
                            access.value = { kind: 'admin' };
                            loading.value = false;
                            return [2 /*return*/];
                        }
                        access.value = { kind: 'caregiver', staffId: sessionStaffId(), category: category };
                        loading.value = false;
                        return [2 /*return*/];
                    case 5:
                        _a = chartInView(data), patientId = _a.patientId, patientName = _a.patientName;
                        canAdd = false;
                        fullAccess = false;
                        if (!data.viewingPatientChart) return [3 /*break*/, 7];
                        return [4 /*yield*/, privStore.ensureLoaded()
                            // The viewer of the chart (the actual acting subject — the session's
                            // permissions from /me stay theirs during patient chart viewing, not
                            // the patient's) keeps their own elevated access when stepping into a
                            // patient's chart: one granted SCHEDULE_ADMINISTER can add/schedule for
                            // any patient. (Main's other route to that, membership of a group named
                            // "Administrators", is the same permission on the port: the
                            // Administrators template grants scheduling:admin.)
                        ];
                    case 6:
                        _d.sent();
                        // The viewer of the chart (the actual acting subject — the session's
                        // permissions from /me stay theirs during patient chart viewing, not
                        // the patient's) keeps their own elevated access when stepping into a
                        // patient's chart: one granted SCHEDULE_ADMINISTER can add/schedule for
                        // any patient. (Main's other route to that, membership of a group named
                        // "Administrators", is the same permission on the port: the
                        // Administrators template grants scheduling:admin.)
                        if (privStore.effectiveGranted(privileges_2.PRIVILEGES.SCHEDULE_ADMINISTER)) {
                            canAdd = true;
                            fullAccess = true;
                        }
                        else {
                            // Main counted PATIENT_SCHEDULING_ADD here only when it was inherited
                            // through a group the patient in view owns, which it checked in the
                            // browser from the privilege's group provenance; /me carries none, so
                            // New Visit follows the grant, as main shows it. The server decides
                            // the booking, and since main #323 it refuses a contact's: a
                            // non-administrator books only visits they are the caregiver on
                            // (SchedulingAuthority::assertMayActOnAppointment), which a contact
                            // never is. Main's own gate refuses it the same way.
                            canAdd = privStore.effectiveGranted(privileges_2.PRIVILEGES.PATIENT_SCHEDULING_ADD);
                        }
                        return [3 /*break*/, 9];
                    case 7: 
                    // True self-service patient (no manager/clinician viewing the chart) — no per-patient
                    // ambiguity here (it's always their own record), so this is a plain
                    // global grant: admin grants PATIENT_SCHEDULING_ADD to the org's
                    // default "Patients" group (or an individual user_override) to let
                    // patients book their own appointments. Without it, a patient can view
                    // their calendar but not the booking flow — see ManageScheduling.vue,
                    // which hides the Appointments sub-tab entirely when this is false.
                    // Since main #323 the server refuses the booking itself (a patient is
                    // never the caregiver on the visit), on main and here alike; the button
                    // still follows the grant, as main's does, until that is decided.
                    return [4 /*yield*/, privStore.ensureLoaded()];
                    case 8:
                        // True self-service patient (no manager/clinician viewing the chart) — no per-patient
                        // ambiguity here (it's always their own record), so this is a plain
                        // global grant: admin grants PATIENT_SCHEDULING_ADD to the org's
                        // default "Patients" group (or an individual user_override) to let
                        // patients book their own appointments. Without it, a patient can view
                        // their calendar but not the booking flow — see ManageScheduling.vue,
                        // which hides the Appointments sub-tab entirely when this is false.
                        // Since main #323 the server refuses the booking itself (a patient is
                        // never the caregiver on the visit), on main and here alike; the button
                        // still follows the grant, as main's does, until that is decided.
                        _d.sent();
                        canAdd = privStore.effectiveGranted(privileges_2.PRIVILEGES.PATIENT_SCHEDULING_ADD);
                        _d.label = 9;
                    case 9:
                        access.value = { kind: 'patient', patientId: patientId, patientName: patientName, canAdd: canAdd, fullAccess: fullAccess };
                        loading.value = false;
                        return [2 /*return*/];
                }
            });
        });
    }
    // Re-resolve whenever the session snapshot changes — not just once on mount —
    // so this stays correct if `allData` populates asynchronously after this
    // composable is first set up, or changes while mounted (e.g. patient chart viewing
    // starting/ending without a full page reload).
    (0, vue_1.watch)(allData, resolve, { immediate: true, deep: true });
    return { access: access, loading: loading, refresh: resolve };
}
